// extracted by mini-css-extract-plugin
module.exports = {"signInLink":"ResetPasswordExpiredErrorNotification_signInLink__2krfQ"};